<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <v-slide-x-reverse-transition>
        <v-alert type="success" class="alert" v-if="alert_success === true">เปลี่ยนข้อมูลเรียบร้อย !</v-alert>
      </v-slide-x-reverse-transition>
      <div class="pa-5">
        <div class="header_title">
          คำสั่งซื้อ {{ order_code }}
        </div>
        <div class="content_list">
          <v-card elevation="6" class="rounded-lg ma-md-2 ma-lg-2 ma-xl-2 mt-5">
            <div class="pa-5">
              <div class="mt-4 mb-4"><b>รายการสินค้า</b></div>
              <v-divider/>
              <v-data-table class="border_table" :headers="header" :items="data_list" :items-per-page="perPage" hide-default-footer mobile-breakpoint="0">
                <template v-slot:item="dataDetail">
                  <tr>
                    <td class="border_table">
                      <div class="mx-auto">
                        <v-img v-if="dataDetail.item.product_picture !== null" class="rounded mx-auto" height="120" width="120" max-width="120" :lazy-src="picture_product" :src="dataDetail.item.product_picture"></v-img>
                        <v-img v-else class="rounded mx-auto" height="120" width="120" max-width="120" :lazy-src="picture_product" :src="picture_product"></v-img>
                      </div>
                    </td>
                    <td class="border_table">
                      <div><b>{{ dataDetail.item.product_name }}</b></div>
                      <div v-if="dataDetail.item.product_list !== null">
                        <div v-for="(data, index) in dataDetail.item.product_list" :key="index">
                          <small class="pl-3">- {{ data.name }} ({{ data.qty }} {{ data.unit_name }})</small>
                        </div>
                      </div>
                    </td>
                    <td class="border_table text-center">{{ dataDetail.item.qty }} {{ dataDetail.item.unit_name }}</td>
                    <td class="border_table text-center">{{ dataDetail.item.warehouse_name }}</td>
                    <td class="border_table text-center">
                      <div v-if="dataDetail.item.detail_lot.length > 0">
                        <div v-for="(data, index) in dataDetail.item.detail_lot" :key="index">
                          <div><b class="lot_number" @click="lot_select(data.product_id, data.unit_id, data.product_name, data.quantity, data.unit_name, dataDetail.item.type, dataDetail.item.unit_name, dataDetail.item.id)">{{ data.product_name }}</b></div>
                        </div>
                      </div>
                    </td>
                    <td class="border_table text-center">
                      <div v-if="dataDetail.item.detail_lot.length > 0">
                        <div v-for="(data, index) in dataDetail.item.detail_lot" :key="index">
                          <div>{{ data.lot_no }}</div>
                        </div>
                      </div>
                    </td>
                    <td class="border_table text-center">
                      <div v-if="dataDetail.item.detail_lot.length > 0">
                        <div v-for="(data, index) in dataDetail.item.detail_lot" :key="index">
                          <div>{{ data.date_expired }}</div>
                        </div>
                      </div>
                    </td>
                    <td class="border_table text-center">
                      <div v-if="dataDetail.item.detail_lot.length > 0">
                        <div v-for="(data, index) in dataDetail.item.detail_lot" :key="index">
                          <div>{{ data.quantity }} {{ data.unit_name }}</div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </div>
<!--            <div class="text-center pa-5 mb-3">-->
<!--              <v-btn large elevation="5" style="font-size: 18px" class="mobile_grid ml-1 mr-1 pa-6 grad-warning-bg white&#45;&#45;text rounded-pill">-->
<!--                บันทึกการแก้ไข-->
<!--              </v-btn>-->
<!--            </div>-->
          </v-card>
          <v-dialog v-model="modal_lots" max-width="1024">
            <v-card class="rounded-xl" elevation="6">
              <v-form ref="get_lot" @submit.prevent="">
                <div class="d-flex justify-space-between">
                  <v-card-title>
                    เลือกล็อตสินค้า
                  </v-card-title>
                  <v-btn icon class="ma-4" @click="modal_lots = false">
                    <v-icon color="grey">mdi-close</v-icon>
                  </v-btn>
                </div>
                <v-card-text>
                  <div class="pl-6 pr-6 pb-6">
                    <div class="grid_flex" style="font-size: 20px">
                      <div class="grid_flex ma-2">
                        <div class="mr-2">สินค้า :</div>
                        <div>{{ get_product_name }}</div>
                      </div>
                      <div class="grid_flex ma-2">
                        <div class="mr-2">จำนวนในคำสั่งซื้อ :</div>
                        <div>{{ get_qty }} {{ get_unit_name }}</div>
                      </div>
                    </div>
                    <div v-if="loading_modal === true">
                      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
                      </v-sheet>
                    </div>
                    <div v-else>
                      <v-card-title>
                        <v-text-field v-model="search" color="#86bc3a" append-icon="mdi-magnify" label="ค้นหา" single-line hide-details></v-text-field>
                      </v-card-title>
                      <v-data-table :headers="header_lots" :items="data_lots" :footer-props="footer_Props" :search="search" mobile-breakpoint="0">
                        <template v-slot:item="dataDetail">
                          <tr>
                            <td>
                              <div class="text-center">{{ dataDetail.item.lot_no }}</div>
                            </td>
                            <td>
                              <div class="text-center">{{ dataDetail.item.date_expired }}</div>
                            </td>
                            <td>
                              <div class="text-center">{{ dataDetail.item.quantity }}</div>
                            </td>
                            <td>
                              <div class="text-center">{{ dataDetail.item.unit_name }}</div>
                            </td>
                            <td>
                              <div class="text-center pa-3">
                                <v-btn x-large type="submit" @click="changeInput(dataDetail.item.product_id, dataDetail.item.lot_no, dataDetail.item.date_expired, dataDetail.item.quantity, dataDetail.item.unit_name)" class="rounded-pill white--text grad-success-bg ">เลือก</v-btn>
                              </div>
                            </td>
                          </tr>
                        </template>
                      </v-data-table>
                    </div>
                  </div>
                </v-card-text>
              </v-form>
            </v-card>
          </v-dialog>
          <v-dialog v-model="modal_lots_2" persistent max-width="1024">
            <v-card class="rounded-xl" elevation="6">
              <v-form ref="get_lot" @submit.prevent="">
                <div class="d-flex justify-space-between">
                  <v-card-title>
<!--                    เลือกล็อตสินค้า <b class="pl-2">( จำนวนรวม {{ (quantity_total) }} {{ unit_name_total }} )</b>-->
                    เลือกล็อตสินค้า
                  </v-card-title>
                  <v-btn icon class="ma-4" @click="modal_lots_2 = false">
                    <v-icon color="grey">mdi-close</v-icon>
                  </v-btn>
                </div>
                <v-card-text>
                  <div class="pl-6 pr-6 pb-6">
                    <div class="grid_flex" style="font-size: 20px">
                      <div class="grid_flex ma-2">
                        <div class="mr-2">สินค้า :</div>
                        <div>{{ get_product_name }}</div>
                      </div>
                      <div class="grid_flex ma-2">
                        <div class="mr-2">จำนวนในคำสั่งซื้อ :</div>
                        <div>{{ get_qty }} {{ get_unit_name }}</div>
                      </div>
                    </div>
                    <div v-if="loading_modal === true">
                      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
                      </v-sheet>
                    </div>
                    <div v-else>
                      <v-form ref="update_lots" @submit.prevent="lot_change">
                        <v-card-title>
                          <v-text-field v-model="search" color="#86bc3a" append-icon="mdi-magnify" label="ค้นหา" single-line hide-details></v-text-field>
                        </v-card-title>
                        <v-data-table :headers="header_lots" :items="data_lots" :items-per-page="perPage" :footer-props="footer_Props" :search="search" mobile-breakpoint="0">
                          <template v-slot:item="dataDetail">
                            <tr>
                              <td>
                                <div class="text-center">{{ dataDetail.item.lot_no }}</div>
                              </td>
                              <td>
                                <div class="text-center">{{ dataDetail.item.date_expired }}</div>
                              </td>
                              <td>
                                <div class="text-center">{{ dataDetail.item.quantity }}</div>
                              </td>
                              <td>
                                <div class="text-center">{{ dataDetail.item.unit_name }}</div>
                              </td>
                              <td class="pa-3">
                                <div class="mt-3 mr-1 v-input__slot">
                                  <v-text-field color="#86bc3a" type="number" label="จำนวน" min="0" :max="quantity_total" @keypress="isOnlyNumber($event)" @input="quantity_all(dataDetail.item.loop_id, dataDetail.item.qty_product)" v-model="dataDetail.item.qty_product" :disabled="disabled_all" required hide-details="auto" outlined></v-text-field>
                                </div>
                              </td>
                            </tr>
                          </template>
                        </v-data-table>
                        <div class="text-center pt-5">
                          <v-btn large elevation="5" type="submit" style="font-size: 18px" class="mobile_grid ml-1 mr-1 pa-6 grad-warning-bg white--text rounded-pill">
                            บันทึกการแก้ไข
                          </v-btn>
                        </div>
                      </v-form>
                    </div>
                  </div>
                </v-card-text>
              </v-form>
            </v-card>
          </v-dialog>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import picture_holder from "@/assets/picture.png";
import picture_product from "@/assets/pill.png";
import {HTTP} from "@/axios";
import {formatNumber, onlyForNumber} from "@/js/handler";
import Swal from "sweetalert2";

export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "Order_retail_edit",
  data() {
    return {
      loading_page: false,
      loading_modal: false,
      modal_lots: false,
      modal_lots_2: false,
      search: '',
      picture_holder: picture_holder,
      picture_product: picture_product,
      disabled_all: false,
      order_code: '',
      get_product_id: null,
      alert_success: false,
      type_main: null,
      get_product_name: '',
      get_qty: '',
      quantity_total: '',
      unit_name_total: '',
      get_unit_name: '',
      get_total_sum: 0,
      grand_total: 0,
      perPage: -1,
      footer_Props: {
        // showFirstLastPage: true,
        // firstIcon: 'mdi-arrow-collapse-left',
        // lastIcon: 'mdi-arrow-collapse-right',
        // prevIcon: 'mdi-minus',
        // nextIcon: 'mdi-plus',
        'items-per-page-text':'รายการต่อหน้า'
      },
      header: [
        {
          text: 'รูป',
          value: 'product_img',
          align: 'center',
          sortable: false,
          fixed: true,
        },
        {
          text: 'รายการสินค้า',
          value: 'product_name',
          align: 'left',
          fixed: true,
        },
        {
          text: 'จำนวนสั่ง',
          value: 'price_unit',
          align: 'center',
          fixed: true,
        },
        {
          text: 'คลังที่อยู่',
          value: 'quantity',
          align: 'center',
          sortable: false,
          fixed: true,
        },
        {
          text: 'รายละเอียด',
          value: 'total',
          align: 'center',
          sortable: false,
          fixed: true,
        },
         {
          text: 'ล็อตสินค้า',
          value: 'total',
          align: 'center',
          sortable: false,
          fixed: true,
        },
         {
          text: 'วันหมดอายุ',
          value: 'total',
          align: 'center',
          sortable: false,
          fixed: true,
        },
        {
          text: 'จำนวน',
          value: 'total',
          align: 'center',
          sortable: false,
          fixed: true,
        },
      ],
      data_list: [],
      header_lots: [
        {
          text: 'ล็อตสินค้า',
          value: '',
          align: 'center',
          fixed: true,
          width: '200px',
        },
        {
          text: 'วันหมดอายุ',
          value: '',
          align: 'center',
          fixed: true,
          width: '200px',
        },
        {
          text: 'จำนวนคงเหลือ',
          value: '',
          align: 'center',
          fixed: true,
          width: '200px',
        },
        {
          text: 'หน่วยนับ',
          value: '',
          align: 'left',
          fixed: true,
          width: '120px',
        },
        {
          text: 'จำนวนการตัดล็อต',
          value: '',
          align: 'center',
          sortable: false,
          fixed: true,
          width: '200px',
        },
        // {
        //   text: 'เลือกล็อต',
        //   value: '',
        //   align: 'center',
        //   sortable: false,
        //   fixed: true,
        //   width: '200px',
        // },
      ],
      data_lots: [],
      loop_id: 0,
    }
  },
  methods: {
    format_number: function(value) {
      return formatNumber(value)
    },
    isOnlyNumber: function (evt) {
      return onlyForNumber(evt)
    },
    async get_data() {
      this.loading_page = true
      await HTTP.post('sell/showlots', {
        order_id: this.$route.params.id
      }).then((res) => {
        if (res.data.success === true) {
          this.loading_page = false
          console.log(res.data.object)
          this.order_code = res.data.object.order_head
          this.data_list = res.data.object.order_lists
        }
      })
    },
    lot_select(product_id, unit_id, product_name, qty, unit_name, type_main, unit_name_main, order_list_id) {
      this.data_lots = []
      this.get_product_id = product_id
      this.get_product_name = product_name
      this.get_unit_name = unit_name
      this.unit_name_total = unit_name_main
      this.type_main = type_main
      // this.modal_lots = true
      this.modal_lots_2 = true
      this.loading_modal = true
      HTTP.post('sell/getlots', {
        product_id: product_id,
        unit_id: unit_id,
        order_list_id: order_list_id,
        order_id: this.$route.params.id,
        type: this.type_main,
      }).then((res) => {
        if (res.data.success === true) {
          this.loading_modal = false
          this.get_qty = res.data.qty_use
          this.quantity_total = res.data.qty_use
          res.data.list.forEach((data) => {
            const loop_id = this.loop_id +=1
            this.data_lots.push({
              loop_id: loop_id,
              id: data.id,
              quantity_total: this.quantity_total,
              date_expired: data.date_expired,
              lot_no: data.lot_no,
              quantity: data.qty_stock,
              unit_id: data.unit_id,
              unit_name: data.unit_name,
              old_qty: data.qty,
              qty_product: data.qty,
              total_max: null,
            })
          })
        }
      })
    },
    changeInput(product_id, lot_no, date_expired, quantity, unit_name) {
      const key = this.get_product_id
      this.data_list.forEach((data) => {
        if (key === data.product_id) {
          data.show_first.lot_no = lot_no
          data.show_first.date_expired = date_expired
          data.qty = quantity
          data.show_first.unit_name = unit_name
        }
      })
      this.alert_success = true
      setTimeout(() => this.alert_success = false, 2000)
    },
    quantity_all(loop_id, qty) {
      let total_qty = 0
      let data_lots = this.data_lots
      data_lots.forEach((data) => {
        total_qty += parseInt(data.qty_product)
        data.total_max = total_qty
        if (data.loop_id === loop_id) {
          if (data.qty_product !== '' && data.qty_product !== null) {
            if (parseInt(data.total_max) <= parseInt(this.quantity_total)) {
              data.qty_product = parseInt(qty)
              this.get_total_sum = data.total_max
            } else {
              Swal.fire({
                text: 'จำนวนสินค้าต้องไม่เกิน ' + this.quantity_total + ' !',
                icon: 'error',
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: `ตกลง`,
                denyButtonText: `ยกเลิก`,
              }).then(() => {
                data.qty_product = data.old_qty
              })
            }
          }
          else {
            total_qty = null
            data.qty_product = null
          }
        }
      })
    },
    lot_change() {
      let data_list = []
      this.data_lots.forEach((data) => {
        data_list.push({
          id: data.id,
          lot_no: data.lot_no,
          qty: data.qty_product,
        })
      })
      if (this.$refs.update_lots.validate()) {
        HTTP.post('sell/changelot', {
          type: this.type_main,
          data_list: data_list
        }).then((res) => {
          if (res.data.success === true) {
            this.modal_lots_2 = false
            this.get_data()
          }
        })
      }
    }
  },
  mounted() {
    this.get_data()
  }
}
</script>

<style scoped>
.header_title {
  color: #8cc63e;
  font-size: 24px;
}
.border_table {
  border: #e0e0e0 solid 1px
}
.lot_number {
  color: #8cc63e;
  cursor: pointer;
}
.grid_flex {
  display: flex;
  justify-content: space-between;
}
.v-input__slot >>> input {
  text-align: center !important;
}
@media only screen and (max-width: 500px) {
  .header_title {
    color: #8cc63e;
    font-size: 24px;
    text-align: center;
  }
  .grid_flex {
    display: grid;
    grid-template-columns: 100%;
  }
}
</style>
